import { getCurrentScope, onScopeDispose } from 'vue';
// Cadence preset for transaction polling — kept declarative so callers don't
// repeat the magic numbers.
export const TRANSACTION_POLL = { remaining: 5, interval: 5000 };
export function usePolling(key) {
    const storageKey = `poll_remaining_${key}`;
    // Active timeout for the in-flight poll, so we can cancel on unmount or on
    // an explicit stop(). One per key — concurrent poll() calls on the same key
    // would cancel each other (current call sites never do this).
    let activeTimeout = null;
    let cancelled = false;
    function clearActive() {
        if (activeTimeout !== null) {
            clearTimeout(activeTimeout);
            activeTimeout = null;
        }
    }
    function poll(options) {
        cancelled = false;
        if (options.remaining <= 0) {
            localStorage.removeItem(storageKey);
            options.onFinish();
            return;
        }
        localStorage.setItem(storageKey, String(options.remaining));
        activeTimeout = setTimeout(() => {
            activeTimeout = null;
            if (cancelled)
                return;
            options.fetch(() => {
                if (cancelled)
                    return;
                options.onPoll();
                if (options.shouldStop()) {
                    localStorage.removeItem(storageKey);
                    options.onFinish();
                    return;
                }
                poll({ ...options, remaining: options.remaining - 1 });
            });
        }, options.interval);
    }
    // Cancel any in-flight poll. Leaves the localStorage counter alone so a
    // later page can resume via getPollRemaining() — matches the existing
    // cross-navigation recovery contract used by ActivityPage and HomePage.
    function stop() {
        cancelled = true;
        clearActive();
    }
    function getPollRemaining() {
        const val = localStorage.getItem(storageKey);
        return val ? parseInt(val) : null;
    }
    // Auto-cancel when the calling component unmounts. Prevents the closure
    // firing against torn-down refs (the old behaviour leaked).
    if (getCurrentScope()) {
        onScopeDispose(stop);
    }
    return { poll, stop, getPollRemaining };
}
